import { Clipboard } from '@angular/cdk/clipboard';
import { CurrencyPipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  CouponTypes,
  LineItem,
  Order,
  OrderStatus,
  Payment,
  PaymentTransaction,
  Shops
} from '@infrab4a/connect';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { DialogService } from 'primeng/dynamicdialog';
import { lastValueFrom, map } from 'rxjs';
import {
  PersonControllerService,
  PersonDetail,
  Reward,
  ShippingCompanyAvailable,
  ShippingCompanyControllerService,
  ShippingOrderRequest,
  ShopOrderControllerService,
  ShopOrderRefundDetail,
  UserControllerService
} from 'src/app/admin-api';
import { ShippingTrackingModalComponent } from 'src/app/components/shipping-tracking-modal/shipping-tracking-modal.component';
import { TableColumn } from 'src/app/components/table';
import {
  ShopOrderRefundResponse,
  ShopOrderService
} from 'src/app/connect-api/api/shop/shop-order.service';
import { ShopPaymentService } from 'src/app/connect-api/api/shop/shop-payment.service';
import { ShopProductService } from 'src/app/connect-api/api/shop/shop-product.service';
import { getShopLabel } from 'src/app/connect-api/enums/ShopMap';
import { PaymentMethod } from 'src/app/connect-api/models/PaymentMethod';
import { PaymentStatus } from 'src/app/connect-api/models/PaymentStatus';
import { Estado, TrackingModel } from 'src/app/models';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';
import { OpenService } from 'src/app/services/open.service';
import { FormUtil } from 'src/app/utils/form.util';
import { GatewayUtil } from 'src/app/utils/gateway.util';
import { environment } from 'src/environments/environment';
import { ShopOrderRefundModalComponent } from '../shop-order-refund-modal/shop-order-refund-modal.component';
import { ShopOrderRefundResultModalComponent } from '../shop-order-refund-result-modal/shop-order-refund-result-modal.component';
import { ShopOrderShoppingRefundModalComponent } from '../shop-order-shopping-refund-modal/shop-order-shopping-refund-modal.component';

@Component({
  selector: 'app-shop-order-detail',
  templateUrl: './shop-order-detail.component.html',
  styleUrl: './shop-order-detail.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService, CurrencyPipe, ConfirmationService]
})
export class ShopOrderDetailComponent implements OnInit {
  private title = inject(Title);
  private shopOrdersService = inject(ShopOrderService);
  private shopPaymentService = inject(ShopPaymentService);
  private router = inject(Router);
  private messageService = inject(MessageService);
  private personService = inject(PersonControllerService);
  private clipboard: Clipboard = inject(Clipboard);
  private titleCasePipe: TitleCasePipe = inject(TitleCasePipe);
  private openService: OpenService = inject(OpenService);
  private currencyPipe = inject(CurrencyPipe);
  private dialog = inject(DialogService);
  private shopOrderService = inject(ShopOrderControllerService);
  private messageSerice = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private shippingCompanyService = inject(ShippingCompanyControllerService);
  private userService = inject(UserControllerService);

  @ViewChild('status') dropdownStatus: Dropdown | undefined;

  @ViewChild('companies') dropdownCompanies: Dropdown | undefined;

  @Input() orderId: string;
  @Input() set tab(tab: number) {
    this.selectedTab = tab;
  }
  protected person: PersonDetail | undefined;
  protected selectedTab = 0;
  protected statusList: string[] = [
    OrderStatus.AGUARDANDO_PAGAMENTO,
    'Preparando pedido',
    OrderStatus.ENVIADO,
    OrderStatus.ENTREGUE,
    OrderStatus.CANCELADO
  ];
  protected changeStatus = false;

  protected cols = [
    new TableColumn.Builder()
      .setHeader('Imagem')
      .setField('image')
      .setFilter(false)
      .setSortable(false)
      .setStyleClass('product-image')
      .setInnerHTML((item: LineItem) => {
        const src = item.image || item.images?.at(0) || '';
        const badge = item.refunded
          ? '<span class="status status--danger product-image__refunded">Estornado</span>'
          : '';
        return `<div class="product-image__cell"><img src="${src}" alt="" />${badge}</div>`;
      })
      .build(),
    new TableColumn.Builder()
      .setHeader('SKU Admin')
      .setField('id')
      .setRouterLink(this.orderRouterLink)
      .setRouterLinkFieldName('id')
      .setBusinessUnit(() => (this.order?.shop === Shops.MENSMARKET ? 2 : 1))
      .build(),
    new TableColumn.Builder()
      .setHeader('EAN')
      .setField('EAN')
      .setRouterLink(this.orderRouterLink)
      .setRouterLinkFieldName('id')
      .setBusinessUnit(() => (this.order?.shop === Shops.MENSMARKET ? 2 : 1))
      .build(),
    new TableColumn.Builder()
      .setHeader('Nome')
      .setField('name')
      .setRouterLink(this.orderRouterLink)
      .setRouterLinkFieldName('id')
      .setBusinessUnit(() => (this.order?.shop === Shops.MENSMARKET ? 2 : 1))
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Marca')
      .setField('brand')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Label')
      .setField('label')
      .setType('text')
      .setSortable(false)
      .setDisplayFunction((product: LineItem) =>
        ShopProductService.getProductLabel(product.label)
      )
      .build(),
    new TableColumn.Builder()
      .setHeader('Preço item')
      .setField('pricePaid')
      .setDisplayFunction((item: LineItem) => item.pricePaid)
      .setType('currency')
      .setCondition('gte')
      .build()
  ];
  refundedCols: TableColumn[];

  order: Order;
  states: Array<Estado>;
  couponDiscount: { type: CouponTypes; value: number };
  tracking: Array<TrackingModel>;
  refunds: ShopOrderRefundDetail[];
  reward: Reward;
  tableReady = false;
  products: LineItem[];
  refundedProducts: Array<LineItem & { refundedAmount: number }>;

  tableFilters: {
    [key: string]: {
      label: string;
      value: 'outlet' | 'on-sale' | 'last-units' | 'glamstar' | '';
    }[];
  } = {
    label: [
      { label: 'Todos', value: '' },
      { label: 'Sem label', value: null },
      { label: 'Outlet', value: 'outlet' },
      { label: 'Promoção', value: 'on-sale' },
      { label: 'Últimas unidades', value: 'last-units' },
      { label: 'Glamstar', value: 'glamstar' }
    ]
  };
  shippingCompanies: Array<ShippingCompanyAvailable & { id: string }>;
  shippingCompanyId: string;
  orderShippingCompany: ShippingCompanyAvailable & { id: string };
  updateCompany = false;
  shippingOrderRequest: ShippingOrderRequest;
  orderLogs: any[];
  showDocumentModal = false;
  selectedDocument: any;
  orderPayments: Payment[] = [];
  showPaymentTransactionModal = false;
  selectedPaymentTransaction: PaymentTransaction;
  paymentCols = [
    new TableColumn.Builder()
      .setHeader('Gateway')
      .setField('paymentProvider')
      .setType('text')
      .setFilter(false)
      .setDisplayFunction((payment: Payment) =>
        this.titleCasePipe.transform(payment.paymentProvider)
      )
      .build(),
    new TableColumn.Builder()
      .setHeader('Valor')
      .setField('totalPrice')
      .setType('currency')
      .setFilter(false)
      .build(),
    new TableColumn.Builder()
      .setHeader('Status')
      .setField('transaction.status')
      .setType('text')
      .setFilter(false)
      .setDisplayFunction((payment: Payment) =>
        this.formatPaymentStatus(this.getPaymentTransactionStatus(payment))
      )
      .build(),
    new TableColumn.Builder().setHeader('Detalhes').setType('button').build()
  ];

  paymentActionButtons = [
    {
      label: 'Ver',
      icon: 'pi pi-eye',
      action: 'viewTransaction',
      display: () => true
    }
  ];

  logCols = [
    new TableColumn.Builder()
      .setHeader('Editado em')
      .setField('updatedBy.updatedAt')
      .setType('date')
      .setFilter(false)
      .build(),
    new TableColumn.Builder()
      .setHeader('Editado por')
      .setField('updatedBy.name')
      .setType('text')
      .setFilter(false)
      .build(),
    new TableColumn.Builder().setHeader('Order').setType('button').build(),
    new TableColumn.Builder()
      .setHeader('Origem')
      .setField('updatedBy.origin')
      .setType('text')
      .setFilter(false)
      .build()
  ];

  logActionButtons = [
    {
      label: 'Ver',
      icon: 'pi pi-eye',
      action: 'viewDocument',
      display: () => true
    }
  ];

  async ngOnInit() {
    if (!this.orderId) {
      AppDialogService.showErrorDialog(
        { message: 'Pedido não encontrado.' },
        true
      );
      return;
    }
    this.orderId = this.orderId.trim();
    LoaderService.showLoader();
    try {
      await this.findOrderById();
      this.setCouponDiscount();
      if (
        this.couponDiscount &&
        this.couponDiscount?.type === CouponTypes.PERCENTAGE
      ) {
        this.order?.lineItems?.forEach((l: any) => {
          l.discount = l.pricePaid * (this.couponDiscount.value / 100);
          l.pricePaidWithDiscounts = l.pricePaid - l.discount;
        });
        this.cols = this.cols.concat([
          new TableColumn.Builder()
            .setHeader('Desconto cupom')
            .setField('discount')
            .setType('currency')
            .setCondition('gte')
            .build(),
          new TableColumn.Builder()
            .setHeader('Preço pago')
            .setField('pricePaidWithDiscounts')
            .setType('currency')
            .setCondition('gte')
            .build()
        ]);
      }
      this.cols.push(
        new TableColumn.Builder()
          .setHeader('Quantidade')
          .setField('quantity')
          .setType('number')
          .setCondition('gte')
          .build()
      );
      this.cols
        .filter((c) => c.routerLink)
        .forEach((c) => (c.routerLink = this.orderRouterLink));
      if (this.order.shop === Shops.GLAMPOINTS) {
        this.cols = this.cols.filter((c) => c.type !== 'currency');
      }
      this.refundedCols = [...this.cols].concat(
        new TableColumn.Builder()
          .setHeader('Usuário')
          .setField('username')
          .setCondition('contains')
          .setType('text')
          .setDisplayFunction((i: LineItem) => this.itemRefund(i)?.username)
          .build(),
        new TableColumn.Builder()
          .setHeader('Valor estorno')
          .setField('quantity')
          .setDisplayFunction((i: LineItem) => this.itemRefund(i)?.amount)
          .setType('currency')
          .setFilter(false)
          .build()
      );
      this.title.setTitle(`Loja - Pedido ${this.orderId}`);
      await Promise.all([
        this.loadPersonalData(),
        this.findStates(),
        this.findTracking(),
        this.findOrderRefunds(),
        this.findShippingCompanies(),
        this.findShippingOrderRequest(),
        this.findOrderLogs(),
        this.findOrderPayments()
      ]);
      await this.findReward();
      this.tableReady = true;
      this.lineItems = this.order.lineItems;
      LoaderService.showLoader(false);
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  private async loadPersonalData() {
    if (
      ['Glamshop', 'Glampoints'].includes(this.order?.shop) &&
      this.order.user?.id
    ) {
      this.person = await lastValueFrom(
        this.personService
          .findPersonInfoById(Number(this.order?.user.id))
          .pipe(map((data) => data.result))
      );
    } else {
      this.person = {
        personId: 0,
        username: this.order?.user?.email,
        name: this.order?.user?.firstName || this.order?.user?.displayName,
        lastName: this.order?.user?.lastName,
        phone: FormUtil.phoneFormatted(Number(this.order?.user.phone)),
        birthday: this.order?.user?.birthday?.toISOString() as any,
        cpf: Number(this.order?.user?.cpf),
        urlImageProfile: this.order?.user?.urlImageProfile
      };
    }
  }

  tabChanged(index: number) {
    this.selectedTab = index;
    this.router.navigate([`/shop-orders/order/${this.orderId}`], {
      queryParams: { tab: index },
      queryParamsHandling: 'merge'
    });
  }

  showDropdown(): void {
    this.changeStatus = true;
    setTimeout(() => {
      this.dropdownStatus?.show();
    });
  }

  async findOrderById() {
    try {
      this.shopOrder = await this.shopOrdersService.getOrderById(this.orderId);
    } catch (error) {
      await this.findOrderByOrderNumber();
    }
  }

  async findOrderByOrderNumber() {
    this.shopOrder = await this.shopOrdersService.getOrderByOrderNumber(
      this.orderId
    );
    if (this.order) {
      this.orderId = this.order.id;
      this.router.navigate([`/shop-orders/order/${this.orderId}`], {
        onSameUrlNavigation: 'ignore'
      });
    } else throw new Error('Pedido não encontrado.');
  }

  async findShippingOrderRequest() {
    try {
      this.shippingOrderRequest = await lastValueFrom(
        this.shopOrderService
          .findShopOrderRequestByOrderNumber(this.order.orderNumber)
          .pipe(map((data) => data.result))
      );
      if (
        this.shippingOrderRequest &&
        !this.statusList.includes(OrderStatus.PENDENTE_REENVIO)
      )
        this.statusList.push(OrderStatus.PENDENTE_REENVIO);
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    }
  }

  async updateShippingOrderRequest() {
    if (this.shippingOrderRequest)
      this.shippingOrderRequest = await lastValueFrom(
        this.shopOrderService
          .updateShopOrderRequest(
            {
              status:
                this.order.status === OrderStatus.PENDENTE_REENVIO
                  ? 'PENDENTE'
                  : this.order.status === OrderStatus.CANCELADO
                    ? 'CANCELADO'
                    : 'CRIADO',
              shippingCompanyName:
                this.shippingCompany?.shippingServiceName ||
                this.shippingCompany?.shippingCompanyName
            },
            this.order.orderNumber
          )
          .pipe(map((data) => data.result))
      );
  }

  async refundShoppingOrder(fullRefund = false) {
    const userInfo = await lastValueFrom(
      this.userService.getInfo().pipe(map((data) => data.result))
    );
    const user = {
      id: userInfo.userId.toString(),
      name: userInfo.displayName,
      email: userInfo.username,
      origin: 'ADMIN'
    };

    const refundableProducts =
      this.order.lineItems?.filter(
        (i) => i.pricePaid && !this.refunds?.some((r) => r.ean === i.EAN)
      ) ?? [];

    if (!fullRefund && refundableProducts.length === 0) {
      AppDialogService.showErrorDialog({
        error: {
          message: 'Não há produtos disponíveis para estorno.'
        }
      });
      return;
    }

    this.dialog
      .open(ShopOrderShoppingRefundModalComponent, {
        header: fullRefund
          ? 'Cancelar pedido ' + (this.order.orderNumber || this.order.id)
          : 'Cancelar produto(s) ' + (this.order.orderNumber || this.order.id),
        data: {
          order: this.order,
          fullRefund,
          lineItems: refundableProducts,
          user
        },
        width: fullRefund ? '500px' : '600px'
      })
      .onClose.subscribe(async (response: ShopOrderRefundResponse) => {
        if (!response) return;

        LoaderService.showLoader();
        try {
          await this.findOrderById();
          await this.findOrderRefunds();
          await this.findOrderPayments();
          this.lineItems = this.order.lineItems;
        } catch (error) {
          AppDialogService.showErrorDialog(error);
        } finally {
          LoaderService.showLoader(false);
        }

        this.dialog.open(ShopOrderRefundResultModalComponent, {
          header: 'Resultado do cancelamento',
          data: { response },
          width: '500px',
          closable: true
        });
      });
  }

  async changeOrderStatus(status?: OrderStatus) {
    // Verifica a transportadora antes de aprovar
    if (
      status === OrderStatus.AGUARDANDO_ENVIO &&
      this.order?.status === OrderStatus.PENDENTE_REENVIO &&
      !this.shippingCompany?.shippingServiceId &&
      !this.shippingCompany?.shippingCompanyId
    ) {
      AppDialogService.showErrorDialog({
        error: {
          message: 'Selecione a transportadora antes de aprovar o pedido.'
        }
      });
      return;
    }

    if (
      status === OrderStatus.AGUARDANDO_ENVIO &&
      this.order?.status === OrderStatus.PENDENTE_REENVIO &&
      !this.shippingOrderRequest?.ticketId
    ) {
      AppDialogService.showErrorDialog({
        error: {
          message: 'Pedidos de reenvio sem Ticket não podem ser aprovados.'
        }
      });
      return;
    }

    try {
      LoaderService.showLoader();

      const removePedidov =
        this.order['pedidov'] &&
        OrderStatus.AGUARDANDO_ENVIO &&
        this.order?.status === OrderStatus.PENDENTE_REENVIO;

      this.shopOrder = await this.shopOrdersService.updateOrderStatus(
        status || this.order.status,
        this.order?.id,
        removePedidov
      );
      await this.updateShippingOrderRequest();
      this.changeStatus = false;
      this.messageService.add({
        severity: 'success',
        detail: 'Status atualizado com sucesso',
        summary: 'Sucesso'
      });
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  copyToClipboard(text: string): void {
    this.clipboard.copy(text);
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: 'Copiado para área de trasnferência'
    });
  }

  async findStates(): Promise<void> {
    try {
      this.states = await this.openService.listStates();
    } catch (error) {
      this.states = [];
      AppDialogService.showErrorDialog(error);
    }
  }

  getTooltip(field?: 'boletoBarcode' | 'boletoUrl' | 'pixQrCode'): string {
    let message = '';
    const paymentMethod =
      this.order.payment.payment_method || this.order.payment['paymentMethod'];
    const boletoExpirationDate =
      this.order.payment.boleto_expiration_date ||
      this.order.payment['boletoExpirationDate'];
    const pixExpirationDate =
      this.order.payment.pix_expiration_date ||
      this.order.payment['pixExpirationDate'];
    if (paymentMethod) {
      switch (paymentMethod) {
        case 'credit_card':
          break;
        default:
          message += this.titleCasePipe.transform(paymentMethod);
          if (this.order.payment.status === 'paid') message += ' pago';
          else if (
            (boletoExpirationDate || pixExpirationDate) &&
            FormUtil.utcDate(
              boletoExpirationDate || pixExpirationDate
            ).getTime() < new Date().getTime()
          )
            message += ' vencido';
          else if (field) {
            switch (field) {
              case 'boletoBarcode':
                return 'Copiar código de barras';
              case 'boletoUrl':
                return 'Ver boleto';
              default:
                return 'Copiar código';
            }
          } else return '';
      }
    }
    return message;
  }

  setCouponDiscount(): void {
    if (this.order?.coupon) {
      const discountPercentage = Math.round(
        100 * (this.order.discount / this.order.subTotalPrice)
      );
      Object.keys(this.order.coupon.discount).forEach((key) => {
        if (
          !this.couponDiscount &&
          this.order.coupon.discount[key].type === CouponTypes.ABSOLUTE &&
          this.order.coupon.discount[key].value === this.order.discount
        ) {
          this.couponDiscount = this.order.coupon.discount[key];
        } else if (
          !this.couponDiscount &&
          this.order.coupon.discount[key].type === CouponTypes.PERCENTAGE &&
          this.order.coupon.discount[key].value === discountPercentage
        )
          this.couponDiscount = this.order.coupon.discount[key];
      });
    }
  }

  async findTracking() {
    if (this.order?.shipping?.invoiceNumber)
      try {
        if (this.order['pedidov'])
          this.tracking = await this.openService.getShippingTrackingByPedidoV(
            this.order['pedidov'].toString()
          );
        if (
          this.order?.shipping?.invoiceNumber &&
          (!this.order['pedidov'] || !this.tracking?.length)
        )
          this.tracking = await this.openService.getShippingTracking(
            Number(this.order.shipping.invoiceNumber)
          );
      } catch (error) {
        AppDialogService.showErrorDialog(error);
      }
  }

  async findOrderRefunds() {
    try {
      if (this.order.orderNumber) {
        this.refunds = await lastValueFrom(
          this.shopOrderService
            .findShopOrderRefundsByOrderNumber(this.order.orderNumber)
            .pipe(map((data) => data.result))
        );
      } else {
        this.refunds = await lastValueFrom(
          this.shopOrderService
            .findShopOrderRefunds(this.order.id)
            .pipe(map((data) => data.result))
        );
      }
    } catch (error) {
      AppDialogService.showErrorDialog(error);
      this.refunds = [];
    }
  }

  async findReward() {
    if (this.person?.personId)
      try {
        this.reward = await lastValueFrom(
          this.shopOrderService
            .findShopOrderReward(this.person.personId, this.order.id)
            .pipe(map((data) => data.result))
        );
      } catch (error) {
        console.log(error);
      }
  }

  openTracking() {
    if (this.tracking?.length)
      this.dialog.open(ShippingTrackingModalComponent, {
        showHeader: true,
        header: 'Rastreio da nota ' + this.order.shipping.invoiceNumber,
        position: 'center',
        data: {
          order: this.order,
          tracking: this.tracking
        },
        dismissableMask: true,
        width: '50vw'
      });
    else
      AppDialogService.showErrorDialog({
        error: {
          message: 'Sem informações de rastreio para exibir.'
        }
      });
  }

  refundOrder(allProducts = false) {
    this.dialog
      .open(ShopOrderRefundModalComponent, {
        header: 'Estornar pedido ' + (this.order.orderNumber || this.order.id),
        data: {
          order: this.order,
          refunds: this.refunds,
          person: this.person,
          reward: this.reward,
          allProducts
        },
        width: '600px'
      })
      .onClose.subscribe((refunds: ShopOrderRefundDetail[]) => {
        if (refunds?.length) {
          this.tableReady = false;
          this.refunds = [...refunds];
          this.messageSerice.add({
            severity: 'success',
            detail: `${refunds.length} produto(s) estornado(s)`,
            summary: 'Sucesso'
          });
          this.lineItems = this.order.lineItems;
          this.tableReady = true;
          if (!allProducts && this.order?.status !== OrderStatus.ENTREGUE)
            this.confirmationService.confirm({
              acceptLabel: 'Sim, alterar!',
              acceptButtonStyleClass: 'p-button-danger',
              rejectButtonStyleClass: 'p-button-primary',
              rejectLabel: 'Não! Manter status atual.',
              message: 'Deseja alterar o status do pedido para "Entregue"?',
              header: 'Status do pedido',
              accept: async () => {
                await this.changeOrderStatus(OrderStatus.ENTREGUE);
              }
            });
          else if (allProducts && this.order?.status !== OrderStatus.CANCELADO)
            this.confirmationService.confirm({
              acceptLabel: 'Sim, alterar!',
              acceptButtonStyleClass: 'p-button-danger',
              rejectButtonStyleClass: 'p-button-primary',
              rejectLabel: 'Não! Manter status atual.',
              message: 'Deseja alterar o status do pedido para "Cancelado"?',
              header: 'Status do pedido',
              accept: async () => {
                await this.changeOrderStatus(OrderStatus.CANCELADO);
              }
            });
          LoaderService.showLoader(false);
        }
      });
  }

  async findShippingCompanies() {
    try {
      this.shippingCompanies = await lastValueFrom(
        this.shippingCompanyService.getShippingCompaniesForShop().pipe(
          map((data) => {
            data.result.sort((a, b) =>
              (a.shippingServiceName || a.shippingCompanyName).localeCompare(
                b.shippingServiceName || b.shippingCompanyName
              )
            );
            return data.result.map((s) => ({
              ...s,
              id: `${s.shippingCompanyId}_${s.shippingServiceId}`
            }));
          })
        )
      );
      this.shippingCompany =
        this.shippingCompanies.find((c) => c.id === this.shippingCompanyId) ||
        this.shippingCompany;
    } catch (error) {
      AppDialogService.showErrorDialog(error);
      this.shippingCompanies = [];
    }
  }

  updateShippingCompany() {
    this.updateCompany = true;
    setTimeout(() => {
      this.dropdownCompanies?.show();
    });
  }

  itemRefund = (item: LineItem) => {
    return this.refunds?.find((r) => r.ean === item.EAN);
  };

  async saveShippingCompany(id: string) {
    if (id) {
      const oldCompany = { ...this.shippingCompany };
      try {
        this.shippingCompany =
          this.shippingCompanies.find((c) => c.id === id) ||
          this.shippingCompany;
        LoaderService.showLoader();
        this.shopOrder = await this.shopOrdersService.updateShippingCompany(
          this.order.id,
          {
            cnpj: this.shippingCompany.cnpj,
            shippingServiceId: this.shippingCompany.shippingServiceId,
            shippingCompanyId: this.shippingCompany.shippingCompanyId,
            description: this.order.shipping?.description,
            serviceName:
              this.shippingCompany.shippingServiceName ||
              this.shippingCompany.shippingCompanyName,
            ShippingCompanyName:
              this.shippingCompany.shippingCompanyName ||
              this.shippingCompany.shippingServiceName ||
              ''
          }
        );
        await this.updateShippingOrderRequest();
        this.messageService.add({
          severity: 'success',
          detail: 'Transportadora atualizada com sucesso',
          summary: 'Sucesso'
        });
        this.updateCompany = false;
      } catch (error) {
        if (this.shippingCompany?.id !== oldCompany.id)
          this.shippingCompany = { ...oldCompany };
        this.shopOrdersService
          .updateShippingCompany(this.order.id, {
            cnpj: oldCompany.cnpj,
            shippingServiceId: oldCompany.shippingServiceId,
            shippingCompanyId: oldCompany.shippingCompanyId,
            description: this.order.shipping?.description,
            serviceName:
              oldCompany.shippingServiceName || oldCompany.shippingCompanyName,
            ShippingCompanyName:
              oldCompany.shippingCompanyName ||
              oldCompany.shippingServiceName ||
              ''
          })
          .then();
        AppDialogService.showErrorDialog(error);
      } finally {
        LoaderService.showLoader(false);
      }
    }
  }

  set lineItems(itens: LineItem[]) {
    this.products = itens.filter(
      (i) => !this.refunds || this.refunds?.every((r) => r.ean !== i.EAN)
    );
    this.refundedProducts = itens
      .filter((i) => this.refunds?.some((r) => r.ean === i.EAN))
      .map(
        (i) =>
          ({
            ...i,
            refundedAmount:
              this.refunds.find((r) => r.ean === i.EAN)?.amount || 0
          }) as LineItem & { refundedAmount: number }
      );
  }

  get isWarningStatus() {
    return (
      this.order?.status === OrderStatus.AGUARDANDO_PAGAMENTO ||
      this.order?.status === OrderStatus.AGUARDANDO_ENVIO ||
      this.order?.status === OrderStatus.ENVIADO ||
      this.order?.status === OrderStatus.PENDENTE_REENVIO
    );
  }

  get productsTotal(): number {
    return this.order?.lineItems?.reduce(
      (sum, i) => sum + (i.price.price || i.price.fullPrice || 0) * i.quantity,
      0
    );
  }

  get subscriberDiscount(): number {
    return this.order?.lineItems?.reduce(
      (sum, i) => sum + i.quantity * (i.price.price - i.pricePaid),
      0
    );
  }

  get pointsUsed(): number {
    return (
      Number(
        (this.order as Order & { pointsUsed?: number })?.pointsUsed
      ) || 0
    );
  }

  get pointsDiscount(): number {
    return (
      Number(
        (this.order as Order & { pointsDiscount?: number })?.pointsDiscount
      ) || 0
    );
  }

  get shippingDiscount(): number {
    return (
      Number(
        (this.order as Order & { shippingDiscount?: number })?.shippingDiscount
      ) || 0
    );
  }

  get methodName(): string {
    return PaymentMethod[
      this.order?.payment.payment_method || this.order.payment['paymentMethod']
    ];
  }

  get shopName(): string {
    return getShopLabel(this.order?.shop);
  }

  get paymentStatus(): string {
    return PaymentStatus[this.order.payment.status];
  }

  get paymentGatewayUrl(): string | null {
    return GatewayUtil.shopPaymentGatewayUrl(
      this.order?.payment,
      environment.production
    );
  }

  get expired(): boolean {
    const paidAt = this.order.payment.paid_at || this.order.payment['paidAt'];
    const paymentMethod =
      this.order?.payment.payment_method || this.order.payment['paymentMethod'];
    const boletoExpirationDate =
      this.order.payment.boleto_expiration_date ||
      this.order.payment['boletoExpirationDate'];
    const pixExpirationDate =
      this.order.payment.pix_expiration_date ||
      this.order.payment['pixExpirationDate'];
    return (
      (paymentMethod === 'boleto' &&
        boletoExpirationDate &&
        FormUtil.utcDate(boletoExpirationDate).getTime() <
          new Date().getTime()) ||
      (paymentMethod === 'pix' &&
        !paidAt &&
        pixExpirationDate &&
        FormUtil.utcDate(pixExpirationDate).getTime() < new Date().getTime())
    );
  }

  get pixExpirationDate(): string {
    return (
      this.order.payment.pix_expiration_date ||
      this.order.payment['pixExpirationDate'] ||
      ''
    );
  }

  get codigoPix(): string {
    return (
      this.order.payment.pix_qr_code || this.order.payment['pixQrCode'] || ''
    );
  }

  get boletoBarCode(): string {
    return (
      this.order.payment.boleto_barcode ||
      this.order.payment['boletoBarcode'] ||
      ''
    );
  }

  get orderRouterLink(): string {
    return this.order?.shop === Shops.GLAMPOINTS
      ? '/products/catalog/product-variant/'
      : '/shop-products/catalog/product/';
  }

  get couponDiscountLabel(): string {
    if (!this.couponDiscount) return undefined;
    return this.couponDiscount?.type === CouponTypes.ABSOLUTE
      ? this.currencyPipe.transform(this.order.discount, 'BRL')
      : `${this.couponDiscount.value.toFixed(2)} %`;
  }

  get refundedAmount() {
    return this.refunded
      ? this.order.totalPrice
      : this.refunds?.reduce((sum, r) => (sum += r.amount), 0) || 0;
  }

  get lineItems() {
    return this.products?.filter((p) => p.pricePaid);
  }

  get glampoints() {
    return (this.reward?.points || 0) / (this.order?.lineItems?.length || 1);
  }

  get refunded() {
    return !this.lineItems?.length;
  }

  get canUpdateShippingCompany() {
    return (
      this.order?.status &&
      [
        OrderStatus.AGUARDANDO_PAGAMENTO,
        OrderStatus.EM_PREPARO,
        OrderStatus.PENDENTE_REENVIO
      ].includes(this.order.status)
    );
  }

  set shippingCompany(
    shippingCompany: ShippingCompanyAvailable & { id: string }
  ) {
    this.shippingCompanyId = shippingCompany?.id;
    this.orderShippingCompany = shippingCompany;
  }

  get shippingCompany() {
    return this.orderShippingCompany;
  }

  get pendingResend() {
    return (
      this.order?.status === OrderStatus.PENDENTE_REENVIO ||
      this.order?.status === ('Aguardando stock para reenvio' as any)
    );
  }

  set shopOrder(order: Order) {
    this.order = order;
    this.shippingCompany = {
      shippingServiceId:
        (this.order?.shipping as any)?.ShippingServiceId ||
        this.order?.shipping?.serviceCode,
      shippingCompanyId:
        this.order?.shipping?.ShippingCompanyId ||
        (this.order?.shipping as any)?.shippingCompanyId,
      shippingServiceName:
        (this.order?.shipping as any)?.serviceName ||
        this.order?.shipping?.ShippingCompanyName,
      id: `${this.order?.shipping?.ShippingCompanyId || (this.order?.shipping as any)?.shippingCompanyId}_${
        (this.order?.shipping as any)?.ShippingServiceId ||
        this.order?.shipping?.serviceCode
      }`
    };
  }

  getSequentialChanges(orders: any[]): any[] {
    const getChangedPaths = (obj1: any, obj2: any, path = ''): string[] => {
      const paths: string[] = [];
      const keys = new Set([
        ...Object.keys(obj1 || {}),
        ...Object.keys(obj2 || {})
      ]);
      for (const key of keys) {
        const fullPath = path ? `${path}.${key}` : key;
        const val1 = obj1?.[key];
        const val2 = obj2?.[key];
        if (
          typeof val1 === 'object' &&
          val1 !== null &&
          typeof val2 === 'object' &&
          val2 !== null
        ) {
          paths.push(...getChangedPaths(val1, val2, fullPath));
        } else if (JSON.stringify(val1) !== JSON.stringify(val2)) {
          paths.push(fullPath);
        }
      }
      return paths;
    };

    const setValueAtPath = (obj: any, path: string, value: any) => {
      const keys = path.split('.');
      let current = obj;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) current[keys[i]] = {};
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
    };

    const getValueAtPath = (obj: any, path: string) => {
      return path.split('.').reduce((o, k) => o?.[k], obj);
    };

    const changes: any[] = [];
    for (let i = 1; i < orders.length; i++) {
      const prev = orders[i - 1];
      const curr = orders[i];
      const changedPaths = getChangedPaths(prev, curr);
      const diff: any = {};
      for (const path of changedPaths) {
        setValueAtPath(diff, path, getValueAtPath(curr, path));
      }
      changes.push(diff);
    }
    return changes;
  }

  async findOrderLogs() {
    const changeLogs = await this.shopOrdersService.getOrderLogs(this.order.id);
    const diffLogs = this.getSequentialChanges(
      changeLogs.map((log) => log.document)
    );

    this.orderLogs = changeLogs.map((log, index) => {
      if (index === 0) return log.document;
      return {
        ...diffLogs[index - 1],
        updatedBy: log.document.updatedBy
      };
    });
  }

  async findOrderPayments() {
    this.orderPayments = await this.shopPaymentService.getPaymentsByOrderId(
      this.order.id
    );
  }

  showOrderDocumentModal(event: any) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { lineItems, ...document } = event.item as Order;
    this.selectedDocument = document;
    this.showDocumentModal = true;
  }

  showPaymentTransactionModalAction(event: { item: Payment }) {
    this.selectedPaymentTransaction = event.item.transaction;
    this.showPaymentTransactionModal = true;
  }

  private getPaymentTransactionStatus(payment: Payment): string | undefined {
    const transaction = payment.transaction as PaymentTransaction & {
      last_transaction?: { status?: string };
    };
    return (
      transaction?.last_transaction?.status || transaction?.status || undefined
    );
  }

  private formatPaymentStatus(status?: string): string {
    if (!status) {
      return '-';
    }
    return PaymentStatus[status] || status;
  }

  get isReshipment() {
    return this.order.isReshipment;
  }

  get canApproveReshipment() {
    return (
      this.order?.status === OrderStatus.PENDENTE_REENVIO && this.hasValidStock
    );
  }

  get hasValidStock() {
    return (
      this.order.lineItems?.every(
        (item) => item.stock.quantity >= item.quantity
      ) ?? false
    );
  }

  async approveReshipment(approved: boolean) {
    if (
      approved &&
      !this.shippingCompany?.shippingServiceId &&
      !this.shippingCompany?.shippingCompanyId
    ) {
      AppDialogService.showErrorDialog({
        error: {
          message: 'Selecione a transportadora antes de aprovar o pedido.'
        }
      });

      return;
    }

    if (
      approved &&
      this.order?.status === OrderStatus.PENDENTE_REENVIO &&
      !this.shippingOrderRequest?.ticketId
    ) {
      AppDialogService.showErrorDialog({
        error: {
          message: 'Pedidos de reenvio sem Ticket não podem ser aprovados.'
        }
      });

      return;
    }

    try {
      LoaderService.showLoader();
      await lastValueFrom(
        this.shopOrdersService.approveOrDisapproveReshipment(
          this.order.orderNumber,
          approved
        )
      );
      await this.findOrderById();

      this.shippingOrderRequest = await lastValueFrom(
        this.shopOrderService
          .updateShopOrderRequest(
            {
              status: approved ? 'CRIADO' : 'CANCELADO',
              shippingCompanyName:
                this.shippingCompany?.shippingServiceName ||
                this.shippingCompany?.shippingCompanyName
            },
            this.order.orderNumber
          )
          .pipe(map((data) => data.result))
      );
    } catch (error) {
      console.error(error);
      AppDialogService.showErrorDialog({
        error: {
          message: error?.error?.message || 'Erro ao aprovar reenvio.'
        }
      });
    } finally {
      this.messageSerice.add({
        severity: 'success',
        detail: `Reenvio ${approved ? 'aprovado' : 'reprovado'} com sucesso`,
        summary: 'Sucesso'
      });
      LoaderService.showLoader(false);
    }
  }

  async revalidateReshipmentStock() {
    try {
      LoaderService.showLoader();
      await lastValueFrom(
        this.shopOrdersService.revalidateReshipmentStock(this.order.orderNumber)
      );
      await this.findOrderById();
    } catch (error) {
      console.error(error);
      AppDialogService.showErrorDialog({
        error: {
          message: error?.error?.message || 'Erro ao revalidar estoque.'
        }
      });
    } finally {
      LoaderService.showLoader(false);
      this.messageSerice.add({
        severity: 'success',
        detail: 'Estoque revalidado com sucesso',
        summary: 'Sucesso'
      });
    }
  }
}
